import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import HostSpotlight from "@/components/HostSpotlight";
import GuestDimensions from "@/components/GuestDimensions";
import ValuePitch from "@/components/ValuePitch";
import ExperienceFlow from "@/components/ExperienceFlow";
import SlotBookingForm from "@/components/SlotBookingForm";
import Footer from "@/components/Footer";

function App() {
  return (
    <div className="App relative">
      <div className="noise-overlay" />
      <Navbar />
      <main>
        <Hero />
        <HostSpotlight />
        <GuestDimensions />
        <ValuePitch />
        <ExperienceFlow />
        <SlotBookingForm />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
